import * as React from "react";
import { NavLink } from "react-router-dom";

const links = [
  { label: "Writing", to: "/blog" },
  { label: "Logs", to: "/logs" },
  { label: "About", to: "/about" },
];

const TopNav = () => (
  <header className="site-header">
    <nav className="site-nav" aria-label="Primary navigation">
      {links.map((link) => (
        <NavLink
          activeClassName="is-active"
          className="site-nav__link"
          exact={link.exact}
          key={link.label}
          to={link.to}
        >
          {link.label}
        </NavLink>
      ))}
    </nav>
  </header>
);

export default TopNav;
